import api from '@/utils/api';

/**
 * delete category
 *
 * @param {string} categoryId - The category id
 * @returns {Promise} The promise object of the api call
 */
const deleteCategoryApi = (categoryId) => api.delete(`category/${categoryId}`);

export default deleteCategoryApi;
